module.exports = __webpack_public_path__ + "static/img/wyfw.24cbb272.png";